function Mainfooter() {
  return (
    <footer className="footer position-absolute w-100 bg-light ">
      <div className="container px-5 py-3">
        <p className="text-muted text-center m-0">
          App author: Piotr Witasik/PdoubleU &copy; 2021
        </p>
      </div>
    </footer>
  );
}

export default Mainfooter;
